/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { compose } from 'redux';
import UserMenu from '../../Components/UserMenu/UserMenu.component';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import layoutsPageStyles from './Layouts.page.styles';
import PageGenericSidebarPageSidebarPropTypes from './PageGenericSidebar.page.sidebar.props';

/**
 * PageGenericSidebarPageSidebarComponent
 * @export
 * @class PageGenericSidebarPageSidebarComponent
 * @extends {React.Component<PageGenericSidebarPageSidebarComponentComposedProps, PageGenericSidebarPageSidebarComponentState>}
 */
export class PageGenericSidebarPageSidebarComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<PageGenericSidebarPageSidebarComponentProps>}
   * @memberof PageGenericSidebarPageSidebarComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`PageGenericSidebarPageSidebar`}
   * @memberof PageGenericSidebarPageSidebarComponent
   */
  static displayName = `PageGenericSidebarPageSidebar`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof PageGenericSidebarPageSidebarComponent
   */
  static propTypes = PageGenericSidebarPageSidebarPropTypes;

  /**
   * Data specific to the `<PageGenericSidebarPageSidebar />` instance
   * @type {PageGenericSidebarPageSidebarComponentState}
   * @memberof PageGenericSidebarPageSidebarComponent
   */
  state = {};

  /**
   * Render the sidebar
   * @returns {React.Component} The rendered `<PageGenericSidebarPageSidebar />`
   * @memberof PageGenericSidebarPageSidebarComponent
   */
  render() {
    return <UserMenu showAvatar={false} />;
  }
}

/** @type {React.ComponentClass<PageGenericSidebarPageSidebarComponentProps>} */
const PageGenericSidebarPageSidebar = compose(withStyles(themeCreateInjectableStyles(layoutsPageStyles), { withTheme: true }))(
  PageGenericSidebarPageSidebarComponent,
);

export default PageGenericSidebarPageSidebar;
